const ContactSubcategory = () =>
  import(
    /* webpackChunkName: "base-info-crm-contact-subcategory" */ '@/pages/base-info/crm/contact-subcategory/index.vue'
    )
const CreateContactSubcategory = () =>
  import(
    /* webpackChunkName: "base-info-crm-contact-subcategory" */ '@/pages/base-info/crm/contact-subcategory/create.vue'
    )
const EditContactSubcategory = () =>
  import(
    /* webpackChunkName: "base-info-crm-contact-subcategory" */ '@/pages/base-info/crm/contact-subcategory/edit.vue'
    )

export default {
  path: 'contact-subcategory',
  meta: {
    label: 'subCategory',
    auth: 'subcategory'
  },
  component: {
    name: 'subCategory',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'BaseInfoCrmContactSubcategory',
      path: '/',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: ContactSubcategory
    },
    {
      name: 'BaseInfoCreateCrmContactSubcategory',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: CreateContactSubcategory
    },
    {
      name: 'BaseInfoEditCrmContactSubcategory',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: EditContactSubcategory,
      props: true
    }
  ]
}
